<div class="user-list-main mb-5 app-scrollbar">
  <div class="row pt-4 pl-3 pr-1 item">
    <div class="col-1 m-auto">
      <ng-container [ngSwitch]="userType">
        <ng-container *ngSwitchCase="('SHOWINGS' | translate)">
          <img src="assets/svg/ico-home-with-hand-circle.svg" alt="home icon" />
        </ng-container>
        <ng-container *ngSwitchCase="('MAINTENANCE' | translate)">
          <img
            src="assets/svg/ico-traffic-cone-circle.svg"
            alt="maintenance icon"
          />
        </ng-container>
        <ng-container *ngSwitchCase="('PRIVATE_EVENTS' | translate)">
          <img
            src="assets/svg/icon-glass-circle.svg"
            alt="private event icon"
          />
        </ng-container>
      </ng-container>
    </div>
    <div class="col-6 d-flex align-items-center">
      <div class="pt-1">
        <span class="count mx-2">
          {{ totalCount }}
        </span>
      </div>
      <div class="pt-6">
        <p class="heading">{{ userType }}</p>
      </div>
    </div>

    <div
      class="col-4 d-flex px-4 pl-5 text-right align-self-center justify-content-end"
    >
      <!-- <button
        type="button"
        class="add-user btn outline-none pointer-cursor ml-md-5 ml-lg-5"
        (click)="addUser()"
        [controlDisabled]="[PageName.Users, CONSTANTS.CREATE]"
      >
      </button> -->
      <img
        class="pointer-cursor"
        src="assets/svg/ico-add.svg"
        (click)="addUser()"
        [controlDisabled]="[PageName.Users, CONSTANTS.CREATE]"
      />
    </div>
  </div>
  <div class="row px-1">
    <hr class="col-11 divider" />
  </div>
  <div class="content pb-5 position-relative mt-2">
    <div class="row my-2 mx-2 sticky-search-filter">
      <app-search-field
        class="col-8 offset-1"
        (searchCriteria)="searchThis($event)"
      ></app-search-field>
      <div class="col-2 text-right">
        <span class="position-relative">
          <img
            class="menu-icon pointer-cursor"
            src="assets/svg/ico-menu-circle.svg"
            (click)="selectFilter()"
          />
          <span class="mf-badge" *ngIf="filterCount !== 0">
            <span class="circle-content">
              {{ filterCount || "" }}
            </span>
          </span>
        </span>
      </div>
    </div>

    <div class="mt-4 main-containter">
      <ng-container *ngIf="!searchKeyPress && userList$?.users as userList">
        <ng-container *ngIf="userList.length > 0">
          <ng-container
            *ngFor="let user of userList; let i = index; trackBy: trackByUsers"
          >
            <ng-container *ngIf="!user?.isExpired">
              <div class="col-11 offset-1 pl-2" *ngIf="checkIfNew(user?.name)">
                <div class="heading mb-1 mt-2">
                  {{ user?.name.charAt(0).toUpperCase() }}
                </div>
              </div>
              <a
                [routerLink]="[
                  encode(this.userType!),
                  encode(this.userGroupId!),
                  encode(user?.userId)
                ]"
                routerLinkActive="active"
              >
                <div class="row py-2 mx-2 item pointer-cursor">
                  <div class="col-1 m-auto">
                    <app-profile-picture [name]="user?.name" [userData]="user">
                    </app-profile-picture>
                  </div>
                  <div class="col-5">
                    <div class="col-12 heading3">
                      <app-with-tooltip [showHelpCursor]="true">{{
                        user?.name
                      }}</app-with-tooltip>
                    </div>
                    <div class="col-12 status mt-1">
                      <ng-container *ngIf="user?.unitName">
                        {{ user?.unitName }}
                      </ng-container>
                      <ng-container *ngIf="user?.accessPointName">
                        {{ user?.accessPointName }}
                      </ng-container>
                      {{ user?.userType }} {{ user?.buildingName }}
                    </div>
                  </div>
                  <div
                    class="col-5 d-flex px-1 pr-3 text-right align-self-center justify-content-end"
                  >
                    <ng-container *appHideAccess="commonAccessControl">
                      <div
                        class="ml-auto col-8"
                        *ngIf="user?.startTime !== null"
                      >
                        <app-with-tooltip [showHelpCursor]="true">
                          {{
                            user?.startTime
                              | parsedDateTime : "yyyy/MM/dd hh:mm a"
                          }}
                          -
                          {{
                            user?.expireTime !== null &&
                            user?.expireTime !== undefined &&
                            convertNumber(user?.expireTime) !== 0
                              ? (user?.expireTime
                                | parsedDateTime : "yyyy/MM/dd hh:mm a")
                              : ("NO_EXPIRY" | translate)
                          }}
                        </app-with-tooltip>
                      </div>
                      <div class="time mr-3" *ngIf="user?.repeatStartTime">
                        {{
                          user?.repeatStartTime
                            | parsedTime : "HH:mm" : "hh:mm a"
                        }}
                        <ng-container *ngIf="user?.repeatEndTime"
                          >-</ng-container
                        >
                        {{
                          user?.repeatEndTime | parsedTime : "HH:mm" : "hh:mm a"
                        }}
                        <div class="ml-auto col-5">
                          <app-with-tooltip [showHelpCursor]="true">
                          {{ user?.repeatDays | parsedDateTime : 'EEEE' : "EEEE" }}
                          </app-with-tooltip>
                        </div>
                      </div>
                    </ng-container>
                    <div class="align-self-center">
                      <img
                        src="assets/svg/ico-chevron-forward-outline.svg"
                        alt="forward icon"
                      />
                    </div>
                  </div>
                </div>
              </a>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="searchKeyPress">
        <div class="centered">
          <app-nested-loader></app-nested-loader>
        </div>
      </ng-container>
      <ng-container *ngIf="!searchKeyPress && userList$ as userList">
        <ng-container *ngIf="userList?.users?.length < 1">
          <div
            class="mx-xs-3 d-flex flex-column justify-content-center align-items-center sub-container"
          >
            <div class="text-container">
              <div class="icon-container ml-auto mr-auto mb-3">
                <img src="assets/svg/ico-user.svg" class="user-icon" />
              </div>
              <div class="text-center mb-4 mt-auto">
                <p class="empty-box">{{ 'NO_USER_IN_THIS_GROUP' | translate }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isNestedUserCall">
        <div class="centered">
          <app-nested-loader></app-nested-loader>
        </div>
      </ng-container>
      <ng-container *ngIf="!searchKeyPress && userList$ as userList">
        <ng-container *ngIf="userList.length < 1">
          <div
            class="mx-xs-3 d-flex flex-column justify-content-center align-items-center sub-container"
          >
            <div class="text-container">
              <div class="icon-container ml-auto mr-auto mb-3">
                <img src="assets/svg/ico-user.svg" class="user-icon" />
              </div>
              <div class="text-center mb-4 mt-auto">
                <p class="empty-box">{{ 'NO_USER_IN_THIS_SITE' | translate }}</p>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
